import { LocationStrategy } from "@angular/common";
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { HttpService } from "../../../misc/http.service";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import { MiscService } from "app/shared/misc.service";

@Component({
  selector: "app-seminav",
  templateUrl: "./seminav.component.html",
  styleUrls: ["./seminav.component.scss"],
})
export class SeminavComponent implements OnInit {
  @Input() isOverview = false;
  @Input() isJobDetail = false;
  @Input() isJobCreate = false;
  @Input() isJobUpdate = false;
  @Input() isSettings = false;
  @Input() isAttendance = false;
  @Input() isAttendanceDetails = false;
  @Input() isBroadcast = false;
  @Input() isBroadcastCreate = false;
  @Input() isBroadcastView = false;
  @Input() isAllContinent = false;
  @Input() isNewContinent = false;
  @Input() isAssignPastor = false;
  @Input() attendanceContinent = "";
  @Input() extra = "";
  @Input() isPastor = false;
  @Input() isReport = false;
  @Input() isMedia = false;
  @Input() isNewMedia = false;
  @Input() userDetail: any = {};
  @Output() continentAddModal = new EventEmitter();
  @Input() isAllPastor = false;
  @Input() isPendingPastors = false;
  @Input() isNewConvert = false;
  @Input() isNewPastor = false;
  @Input() isAllChurches = false;
  @Input() isChurchCreate = false;
  @Input() isChurchUpdate = false;
  @Input() isReview = false;
  @Input() isManagement = false;
  @Input() managementTitle = "";
  @Input() isJob = false;
  @Input() isJobTitle = "";
  @Input() jobDetail: any;
  @Input() reportTitle = "";
  @Input() isSendReport = false;
  @Input() sendReportTitle = "";
  @Input() isUpdateReportZone = false;
  @Input() updateReportZone = "";

  public showChurchMenu = ["Global Pastor"];

  //   managementTitle: string
  public userData: any;
  public userTypeValue: any;

  @Output() loadDashboardMetrics = new EventEmitter<any>();
  constructor(
    private locationStrategy: LocationStrategy,
    private router: Router,
    private miscService: MiscService,
    private httpService: HttpService,
  ) {
    this.userData = this.miscService.getLoggedInUserDetails();
  }

  ngOnInit(): void {}

  back = () => {
    this.locationStrategy.back();
  };

  newBrodcast = () => {
    this.router.navigate(["/app/dashboard/broadcast/create"]);
  };

  newMedia = () => {
    this.router.navigate(["/app/dashboard/media/create"]);
  };

  newContinent = () => {
    this.router.navigate([`/app/dashboard/management/church/all/create`]);
    // this.continentAddModal.emit()
  };

  newUser = () => {
    this.router.navigate([`/app/dashboard/management/users/all/create`]);
    // this.router.navigate([`/app/dashboard/management/${this.userTypeValue?.toLowerCase()}/pastors/all/create`]);
  };
  newChurch = () => {
    this.router.navigate([`/app/dashboard/management/church/all/create`]);
    // this.router.navigate([`/app/dashboard/management/${this.userTypeValue?.toLowerCase()}/church/all/create`]);
  };

  // getUserDetails(): Observable<any> {
  //     return this.httpService.getDataWithHeaders(environment.SERVER_URL + "/user/details");
  // }

  newManagement = () => {
    switch (this.managementTitle) {
      case "Branches":
        this.router.navigate([`/app/dashboard/management/branch/create`]);
        break;
      case "Areas":
        this.router.navigate([`/app/dashboard/management/area/create`]);
        break;
      case "Hfc":
        this.router.navigate([`/app/dashboard/management/hfc/create`]);
        break;
      case "Province":
        this.router.navigate([`/app/dashboard/management/area/create`]);
        break;
      case "District":
        this.router.navigate([`/app/dashboard/management/district/create`]);
        break;
      case "Zones":
        this.router.navigate([`/app/dashboard/management/zone/create`]);
        break;
      case "Cells":
        this.router.navigate([`/app/dashboard/management/cell/create`]);
        break;
      case "Clusters":
        this.router.navigate([`/app/dashboard/management/cluster/create`]);
        break;

      default:
        break;
    }
  };

  reloadMetrics() {
    this.loadDashboardMetrics.emit();
  }
}
